import React from "react";
import { onboardingConstants } from "../../../_redux/_constants";
import { NicForm } from "./forms/NICForm";
import { RegistrationOption } from "./forms/RegistrationOption";
import { NoCustomerPage } from "./NoCustomerPage";
import { DeditCardDetails } from "./forms/DebitCard";
import { UsernameForm } from "./forms/UsernameForm";
import { NewPasswordForm } from "./forms/NewPasswordForm";
import { NewDisplayNameForm } from "./forms/NewDisplayNameForm";
import { AccountNumberForm } from "./forms/AccountNumberForm";
import { VerificationOption } from "./forms/VerificationOption";
import { VerificationInProgressScreen } from "./forms/VerificationInProgressScreen";
import { SuccessPage } from "./SuccessPage";
import { ErrorPage } from "./ErrorPage";
import { CreditCardDetails } from "./forms/CreditCard";

export default function renderStep(key, props) {
  let mainKey = key;

  switch (mainKey) {
    case onboardingConstants.NIC_PASSPORT_VALIDATION_STEP:
      return (
        <NicForm
          setIsFormDirty={props?.setIsFormDirty}
          closeBtn={props?.cancelBtnClick}
          changeFlowStep={props?.changeFlowStep}
        />
      );

    case onboardingConstants.SELECT_REGISTRATION_OPTION_STEP:
      return (
        <RegistrationOption
          setIsFormDirty={props?.setIsFormDirty}
          closeBtn={props?.cancelBtnClick}
          changeFlowStep={props?.changeFlowStep}
        />
      );

    // case onboardingConstants.REGISTRATION_OPTION_DEBIT_CARD:
    //   return (
    //     <DeditCardDetails
    //       setIsFormDirty={props?.setIsFormDirty}
    //       closeBtn={props?.cancelBtnClick}
    //       changeFlowStep={props?.changeFlowStep}
    //     />
    //   );

    // case onboardingConstants.REGISTRATION_OPTION_CREDIT_CARD:
    //   return (
    //     <CreditCardDetails
    //       setIsFormDirty={props?.setIsFormDirty}
    //       closeBtn={props?.cancelBtnClick}
    //       changeFlowStep={props?.changeFlowStep}
    //     />
    //   );

    case onboardingConstants.REGISTRATION_OPTION_CASA_ACCOUNT:
      return (
        <AccountNumberForm
          setIsFormDirty={props?.setIsFormDirty}
          closeBtn={props?.cancelBtnClick}
          changeFlowStep={props?.changeFlowStep}
        />
      );

    case onboardingConstants.SELECT_VERIFICATION_OPTION_STEP:
      return (
        <VerificationOption
          setIsFormDirty={props?.setIsFormDirty}
          closeBtn={props?.cancelBtnClick}
          changeFlowStep={props?.changeFlowStep}
        />
      );

    case onboardingConstants.ONBOARDING_USERNAME_STEP:
      return (
        <UsernameForm
          setIsFormDirty={props?.setIsFormDirty}
          closeBtn={props?.cancelBtnClick}
          changeFlowStep={props?.changeFlowStep}
          clearEphemeralPassword={props?.clearEphemeralPassword}
        />
      );

    case onboardingConstants.ONBOARDING_PASSWORD_STEP:
      return (
        <NewPasswordForm
          setIsFormDirty={props?.setIsFormDirty}
          closeBtn={props?.cancelBtnClick}
          changeFlowStep={props?.changeFlowStep}
          setEphemeralPassword={props?.setEphemeralPassword}
          getEphemeralPassword={props?.getEphemeralPassword}
        />
      );

    case onboardingConstants.ONBOARDING_DISPLAY_NAME_STEP:
      return (
        <NewDisplayNameForm
          setIsFormDirty={props?.setIsFormDirty}
          closeBtn={props?.cancelBtnClick}
          changeFlowStep={props?.changeFlowStep}
          getEphemeralPassword={props?.getEphemeralPassword}
          clearEphemeralPassword={props?.clearEphemeralPassword}
        />
      );

    case onboardingConstants.VERIFICATION_IN_PROGRESS_STEP:
      return (
        <VerificationInProgressScreen
          setIsFormDirty={props?.setIsFormDirty}
          closeBtn={props?.cancelBtnClick}
          changeFlowStep={props?.changeFlowStep}
        />
      );

    case onboardingConstants.PROCESS_SUCCESSFUL_STEP:
      return (
        <SuccessPage
          setIsFormDirty={props?.setIsFormDirty}
          closeBtn={props?.cancelBtnClick}
          changeFlowStep={props?.changeFlowStep}
        />
      );

    case onboardingConstants.PROCESS_UNSUCCESSFUL_STEP:
      return (
        <ErrorPage
          setIsFormDirty={props?.setIsFormDirty}
          closeBtn={props?.cancelBtnClick}
          changeFlowStep={props?.changeFlowStep}
        />
      );

    case onboardingConstants.NOT_A_LOLC_CUSTOMER_PAGE:
      return <NoCustomerPage />;
  }
}
